<template>
  <div class="ggu-offer">
      <!--offer获得-->
      <div class="harvest">
        <div class="title-bar">
          <div class="left">
            <i class="iconfont icon-biaoqian"></i>世毕盟学员2020 Fall部分录取
          </div>
        </div>
        <div class="tips">以下录取案例，均实名制备案，接受学员和家长的监督!</div>

        <div class="list">
          <ul class="clear">
            <li v-for="(item,index) in offerCountList" :key="index" @click="showthisOffer(item.title)">
              <div class="logo">
                <img :src="GetSrc(item.title)" />
              </div>
              <div class="name">{{item.title}}</div>
              <div class="count">{{item.count}}</div>
            </li>
          </ul>
        </div>

        <!--准六大-->
        <div class="six-major">
          <div class="clear">
            <div class="left">
              <div class="name">准八大</div>
              <div class="count">offer</div>
            </div>
            <div class="right">
              <ul>
                <li v-for="(item,index) in sixMajorList" :key="index" @click="showSixOffer(item.title)">
                  <span class="name">{{item.title}}</span>
                  <span class="count">{{item.count}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!--banner-->
      <div class="banner">
        <img src="@/assets/img/banner_2020.jpg" />
      </div>

      <!--最新动态-->
      <div class="record">
        <div class="title-bar">
          <div class="left">
            <i class="iconfont icon-duihua"></i>最新动态
          </div>
          <div class="right">链接100%来自GGU Consulting公众号</div>
        </div>
        <div class="list">
          <ul :class="{'open-ul':!isFold}">
            <li v-for="(item,index) in newList" :key="index" :id="item.id" @click="goVx(item.link)">
              <span>{{index+1}}</span>
              {{item.title}}
            </li>
          </ul>
        </div>
        <div v-if="newList.length > 3">
          <div class="fold-btn" @click="foldClick()" v-if="isFold">
            展开
            <span>
              <i></i>
            </span>
          </div>
          <div class="fold-btn" @click="foldClick()" v-else>
            收起
            <span>
              <i class="sq-icon"></i>
            </span>
          </div>
        </div>
      </div>

      <!--八大offer-->
      <div class="six-offer">
        <div class="title-bar">
          <img src="@/assets/img/six-offer-icon.png" />
          <span>八大Offer榜</span>
          <img src="@/assets/img/six-offer-icon2.png" />
        </div>
        <ul class="list-data" id ="list-data">
          <li
            v-for="(item,index) in offerList"
            :key="index"
            class="ttuu"
            :id="item.cate + '1'"
            :class="{'active': projectIndex == index}"
            @click="sixOfferClick(index,item)"
          >
            <div class="list">
              <div class="title">
                <span class="name">
                  <i :class="{'active':projectIndex == index}"></i>
                  {{item.cate}}
                </span>
                <span class="count">{{item.count}}</span>
              </div>
            </div>
            <div
              class="tips"
              v-for="(items,index) in item.list"
              :key="'i' + index"
              @click.stop="goVx(items.link)"
            >
              <div class="left">{{items.serial_number}}<span>枚</span></div>
              <div class="center">{{items.title}}</div>
              <div class="right">
                <img :src="imgUrl + items.image" />
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!--准八大榜-->
      <div class="six-offer z-six-offer">
        <div class="title-bar">
          <img src="@/assets/img/six-offer-icon.png" />
          <span>准八大Offer榜</span>
          <img src="@/assets/img/six-offer-icon2.png" />
        </div>
        <ul class="list-data">
          <li
            v-for="(item,index) in zOfferList"
            :key="index"
            :id="item.cate + '1'"
            :class="projectIndex == index?'active':''"
            @click="zSixOfferClick(index,item)"
          >
            <div class="list">
              <div class="title">
                <span class="name">
                  <i :class="{'active':projectIndex == index}"></i>
                  {{item.cate}}
                </span>
                <span class="count">{{item.count}}</span>
              </div>
            </div>
            <div
              class="tips"
              v-for="(items,index) in item.list"
              :key="'i' + index"
              @click.stop="goVx(items.link)"
            >
              <div class="left">{{items.serial_number}}<span>枚</span></div>
              <div class="center">{{items.title}}</div>
              <div class="right">
                <img :src="imgUrl + items.image" />
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!--其他offer-->
      <div class="six-offer other-offer">
        <ul class="list-data">
          <li
            :class="isOtherOffer?'active':''"
            @click="otherOfferClick()"
          >
            <div class="list">
              <div class="title">
                <div class="content">
                  <span class="name">
                    <i :class="{'active':isOtherOffer}"></i>其他部分录取
                  </span>
                  <span class="count">
                    <span class="right">Hot</span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="tips"
              v-for="(items,index) in otherOfferList.list"
              :key="'i' + index"
              @click.stop="goVx(items.link)"
            >
              <div class="left">{{items.serial_number}}<span>枚</span></div>
              <div class="center">{{items.title}}</div>
              <div class="right">
                <img :src="imgUrl + items.image" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    <img src="@/assets/img/offer_2021.png" class="pastLogo" @click="getPast"/>
  </div>
</template>

<script>
const imgUrl = "http://www.gguconsulting.com/Public/img/";
import api from "@/api/offer";
export default {
  data() {
    return {
      imgUrl,
      isFold: true,
      offerCountList: {}, //offer获得
      sixMajorList: {}, //准八大
      newList: {}, //最新动态
      offerList: {}, //八大offer榜
      zOfferList: {}, //准八大offer榜
      otherOfferList:{}, //其他offer榜
      projectIndex: "CMU",//2020
      isOtherOffer:true,
    };
  },
  methods: {
    getPast(){
      this.$emit('offerYear',"2021");
    },
    //offer获得学习logo
    GetSrc(type) {
      switch (type) {
        case "Harvard":
          return require("../../assets/img/logo1.png");
        case "MIT":
          return require("../../assets/img/logo2.png");
        case "Princeton":
          return require("../../assets/img/logo3.png");
        case "Stanford":
          return require("../../assets/img/logo4.png");
        case "Berkeley":
          return require("../../assets/img/logo5.png");
        case "Caltech":
          return require("../../assets/img/logo6.png");
        case "Oxford":
          return require("../../assets/img/logo7.png");
        case "Cambridge":
          return require("../../assets/img/logo8.png");
      }
    },
    //动态折叠
    foldClick() {
      this.isFold = !this.isFold;
    },
    //去微信公众号
    goVx(link) {
      window.open(link, "_blank");
    },
    //八大offer榜折叠功能
    sixOfferClick(index) {
      if (this.projectIndex == index) {
        this.projectIndex = 1000;
      } else {
        this.projectIndex = index;
      }
    },
    //准八大offer榜折叠功能
    zSixOfferClick(index) {
      if (this.projectIndex == index) {
        this.projectIndex = 1000;
      } else {
        this.projectIndex = index;
      }
    },
    //其他offer折叠功能
    otherOfferClick(){
      this.isOtherOffer = !this.isOtherOffer;
    },
    //获取offer数据
    async getOfferListCount() {
      try {
        let re = await api.offer_count_list();
        this.offerCountList = re.data.data.list;
      } catch (error) {
        console.error(error);
      }
    },
    //获取准八大数据
    async quasisixmajorList() {
      try {
        let re = await api.quasisixmajor_list();
        this.sixMajorList = re.data.data.list;
      } catch (error) {
        console.error(error);
      }
    },
    //获取最新动态
    async latestdevelopmentsList() {
      try {
        let re = await api.latestdevelopments_list();
        this.newList = re.data.data.list;
      } catch (error) {
        console.error(error);
      }
    },
    //获取八大offer榜
    async GetOfferList() {
      try {
        let re = await api.offer_list();
        this.offerList = re.data.data.list;
        this.projectIndex = Object.keys(re.data.data.list)[0];
      } catch (error) {
        console.error(error);
      }
    },
    //获取准八大offer榜
    async GetOfferQuasisixmajor() {
      try {
        let re = await api.offer_quasisixmajor();
        this.zOfferList = re.data.data.list;
        this.projectIndex = Object.keys(re.data.data.list)[0];
      } catch (error) {
        console.error(error);
      }
    },
    //获取其他offer榜
    async GetOther_offer() {
      try {
        let re = await api.other_offer();
        this.otherOfferList = re.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    //点击八大offer显示对于的详情
    showthisOffer(type){
      this.projectIndex = type;
      let that= this;
      setTimeout(function(){ 
        window.scrollTo({
        top: document.querySelector('#' + type + '2').offsetTop,
        behavior: "smooth"
        });
      }, 301);
       
    },
    showSixOffer(type){
      this.projectIndex = type;
      setTimeout(function(){ 
        window.scrollTo({
          top: document.querySelector('#' + type + '1').offsetTop,
          behavior: "smooth"
        });
      }, 301); 
    }
  },
  created() {
    this.getOfferListCount();
    this.quasisixmajorList();
    this.latestdevelopmentsList();
    this.GetOfferList();
    this.GetOfferQuasisixmajor();
    this.GetOther_offer();
  }
};
</script>

<style lang="less" scoped>
//banner
.banner {
  width: calc(~"100% - 60px");
  margin-left:30px;
  img {
    width: 100%;
    height:auto;
  }
}
//offer获得
.harvest {
  width: 100%;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  .title-bar {
    height: 80px;
    border-bottom: 1px solid #f7f7f7;
    line-height: 80px;
    .left {
      float: left;
      i {
        width: 16px;
        height: 21px;
        font-size: 28px;
        margin: 0 15px 0 30px;
        color: #000;
        display: inline-block;
      }
      font-size: 30px;
      color: #000;
      font-weight: 600;
    }
    .right {
      float: right;
      font-size: 22px;
      color: #999;
      margin-right: 25px;
    }
  }
  .tips {
    font-size: 26px;
    color: #B13143;
    margin: 21px 28px 26px;
  }
  .list {
    margin: 0 26px;
    padding-bottom: 17px;
    border-bottom: 1px solid #f7f7f7;
    li {
      width: calc(~"(100% - 54px) / 4");
      height: 174px;
      float: left;
      background: rgba(198, 50, 50, 0.1);
      margin: 0 18px 16px 0;
      border-radius: 10px;
      text-align: center;
      // font-family:"PingFang SC";
      .logo {
        width: 67px;
        height: 66px;
        border-radius: 50%;
        margin: 18px auto 5px auto;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .name {
        font-size: 24px;
        color: #333;
      }
      .count {
        font-size: 32px;
        font-weight: 600;
        color: #b82624;
      }
      &:nth-child(4n) {
        margin-right: 0px;
      }
      &:last-child {
        background: rgba(213, 89, 104, 0.1);
        .count {
          color: rgba(213, 89, 104, 1);
        }
      }
      &:nth-child(2) {
        background: rgba(198, 50, 50, 0.1);
        .count {
          color: rgba(198, 50, 50, 1);
        }
        img {
          background: url("../../assets/img/logo2.png");
        }
      }
      &:nth-child(3) {
        background: rgba(221, 131, 34, 0.1);
        .count {
          color: rgba(221, 131, 34, 1);
        }
      }
      &:nth-child(4) {
        background: rgba(156, 50, 50, 0.1);
        .count {
          color: rgba(156, 50, 50, 1);
        }
      }
      &:nth-child(5) {
        background: rgba(25, 63, 137, 0.1);
        .count {
          color: rgba(25, 63, 137, 1);
        }
      }
      &:nth-child(6) {
        background: rgba(243, 149, 48, 0.1);
        .count {
          color: rgba(243, 149, 48, 1);
        }
      }
      &:nth-child(7) {
        background: rgba(38, 58, 96, 0.1);
        .count {
          color: rgba(38, 58, 96, 1);
        }
      }
    }
  }
  .six-major {
    padding: 25px 26px;
    overflow: hidden;
    .left {
      width: 160px;
      height: 114px;
      border-radius: 10px;
      float: left;
      color: #fff;
      background: url("../../assets/img/z-six.png");
      background-size: 100% 100%;
      .name {
        font-size: 24px;
        margin: 29px 0 0 18px;
      }
      .count {
        font-size: 28px;
        font-weight: 600;
        margin-left: 18px;
      }
    }
    .right {
      float: right;
      width: calc(~"100% - 182px");
      margin-left: 21px;
      ul {
        overflow: hidden;
        background: rgba(42, 98, 209, 0.1);
        height: 114px;
        border-radius: 10px;
        margin-bottom: 19px;
        li {
          float: left;
          width: calc(~"(100%- 45px) / 4");
          margin-right: 15px;
          font-size: 24px;
          color: #333;
          text-align: center;
          span {
            display: block;
          }
          .name {
            margin: 20px 0 0 0;
          }
          .count {
            font-size: 32px;
            color: #2a62d1;
            font-weight: 600;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .ul-bottom {
        margin-bottom: 0;
      }
    }
  }
}
//最新动态
.record {
  margin-top: 6px;
  padding-bottom: 34px;
  .title-bar {
    height: 80px;
    border-bottom: 1px solid #f7f7f7;
    line-height: 80px;
    .left {
      float: left;
      i {
        width: 28px;
        height: 26px;
        font-size: 24px;
        margin: 0 15px 0 30px;
        color: #000;
        display: inline-block;
      }
      font-size: 30px;
      color: #000;
      font-weight: 600;
    }
    .right {
      float: right;
      font-size: 22px;
      color: #999;
      margin-right: 25px;
    }
  }
  .list {
    ul {
      padding: 0 34px;
      overflow: hidden;
      margin-top: 14px;
      li {
        font-size: 28px;
        color: #333;
        transition: height 0.3s;
        height: 60px;
        line-height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:nth-child(n + 4) {
          height: 0;
        }
        span {
          font-size: 28px;
          margin-right: 28px;
          color: #333;
          font-weight: 600;
        }
        &:nth-child(1) {
          span {
            color: #9c3232;
          }
        }
        &:nth-child(2) {
          span {
            color: #c16c3e;
          }
        }
        &:nth-child(3) {
          span {
            color: #e09545;
          }
        }
      }
    }
    .open-ul {
      li {
        &:nth-child(n + 4) {
          height: 60px;
          transition: height 0.3s;
        }
      }
    }
  }
  .fold-btn {
    text-align: center;
    font-size: 28px;
    color: #2a62d1;
    margin-top: 30px;
    span {
      width: 29px;
      height: 29px;
      background: rgba(42, 98, 209, 0.1);
      margin-left: 16px;
      display: inline-block;
      border-radius: 50%;
      // position: relative;
      // top: 2px;
      text-align: center;
      line-height: 31px;
      i {
        width: 18px;
        height: 14px;
        display: inline-block;
        color: #2a62d1;
        background: url("../../assets/img/more.png");
        background-size: 100% 100%;
        // margin-top:7px;
      }
      .sq-icon {
        transform: rotateZ(180deg);
      }
    }
  }
}
//八大offer榜
.six-offer {
  border-top: 20px solid #f7f7f7;
  padding-bottom: 16px;
  .title-bar {
    text-align: center;
    font-weight: 600;
    font-size: 30px;
    color: #000;
    margin: 41px auto 33px;
    span {
      margin: 0 24px;
    }
    img {
      width: auto;
      height: 15px;
      position: relative;
      top: -2px;
    }
  }
  .list-data {
    li {
      margin-bottom: 10px;
      .list {
        font-size: 28px;
        color: #fff;
        padding: 0 25px;
        .title {
          height: 63px;
          line-height: 53px;
          overflow: hidden;
          .name {
            width: 237px;
            height: 53px;
            background: #162940;
            border-radius: 10px 0px 0px 10px;
            float: left;
            i {
              width: 0;
              height: 0;
              border-top: 7px solid #fff;
              border-bottom: 7px solid transparent;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              margin: 0 21px 0 25px;
              position: relative;
              top: 18px;
            }
            .active {
              border-top: 7px solid transparent;
              border-bottom: 7px solid #fff;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              margin: 0 21px 0 25px;
              position: relative;
              top: -18px;
            }
          }
          .count {
            float: left;
            width: calc(~"100% - 247px");
            height: 53px;
            margin-left: 10px;
            background: rgba(245, 246, 246, 1);
            border-radius: 0px 10px 10px 0px;
            text-align: center;
            color: #b13143;
          }
        }
      }
      .not-count {
        .title {
          i {
            opacity: 0;
          }
          .count {
            font-size: 26px;
            color: #a2a0a0;
          }
        }
      }
      .tips {
        margin: 0 30px;
        border-bottom: none;
        height: 0;
        overflow: hidden;
        transition: all 0.3s;
        &:last-child {
          border-bottom: none;
        }
        .left {
          float: left;
          width: 60px;
          margin: 25px 0 0;
          color: #b13143;
          font-size: 30px;
          span {
            font-size: 18px;
            transform: scale(0.7);
            margin-left: 2px;
          }
        }
        .center {
          width: 490px;
          float: left;
          margin: 20px 37px 15px 20px;
          color: #333;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .right {
          width: 73px;
          height: 73px;
          float: right;
          margin: 25px 0 0;
          img {
            width: 100%;
          }
        }
      }
    }
    .active {
      .tips {
        height: 125px;
        border-bottom: 1px solid #f7f7f7;
        &:last-child {
          margin-bottom:10px;
        }
      }
    }
  }
}
//准八大offer榜
.z-six-offer {
  border-top: 1px solid #f7f7f7;
}
//其他offer
.other-offer {
  border-top: none;
  padding-top: 30px;
  border-top: 1px solid #f7f7f7;
  .list-data {
    li {
      .list {
        .title {
          .content {
            height: 53px;
            border-radius: 10px;
            background: #B13143;
          }
          .name {
            background: #B13143;
            font-weight: 600;
          }
          .count {
            position: relative;
            background: #B13143;
            span {
              float: right;
              font-size: 20px;
              width: 54px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              background: #FFFFFF;
              color: #B13143;
              border-radius: 12px;
              margin: 14px 12px 0 0;
              position: absolute;
              right: 12px;
              top: 0;
            }
          }
        }
      }
    }
  }
}
.pastLogo{
  position: fixed;
  bottom:100px;
  right: 30px;
  width:150px;
  height:150px;
}
</style>